/**
 * Registro de intervalos ligados a la sesion del usuario.
 *
 * Las vistas hacen polling (get-table, estado de reportes, procesos) con
 * setInterval y solo lo limpian cuando el proceso termina, no al desmontarse.
 * Al cerrar sesion (logout, cambio de workspace, 401) esos intervalos seguian
 * vivos: daban 401 contra el backend y, tras el relogin, volvian a disparar
 * con el token nuevo. Se intercepta setInterval globalmente para poder
 * cancelarlos todos en el logout sin modificar cada vista.
 */
const nativeSetInterval = window.setInterval.bind(window)
const nativeClearInterval = window.clearInterval.bind(window)
const sessionIntervals = new Set<number>()

export function installSessionIntervals() {
  window.setInterval = ((
    handler: TimerHandler,
    timeout?: number,
    ...args: any[]
  ) => {
    const id = nativeSetInterval(handler, timeout, ...args)
    sessionIntervals.add(id)
    return id
  }) as typeof window.setInterval

  window.clearInterval = ((id?: number) => {
    if (id !== undefined) sessionIntervals.delete(id)
    nativeClearInterval(id)
  }) as typeof window.clearInterval
}

// Intervalos de UI que no dependen de la sesion (p.ej. el contador de un toast)
// y deben sobrevivir al logout.
export function setUntrackedInterval(
  handler: TimerHandler,
  timeout?: number,
  ...args: any[]
): number {
  return nativeSetInterval(handler, timeout, ...args)
}

export function clearSessionIntervals() {
  sessionIntervals.forEach(id => nativeClearInterval(id))
  sessionIntervals.clear()
}
